import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { MaskedLines, Reveal } from "../components/motion";

const links = [
  ["Home", "/"],
  ["Employers", "/employers"],
  ["Individuals", "/individuals"],
  ["Contact", "/contact"],
];

export default function NotFound() {
  return (
    <div data-testid="not-found-page">
      <section className="mx-auto max-w-4xl px-6 pb-28 pt-36 lg:px-10 lg:pt-44">
        <h1 className="font-mono text-xs uppercase tracking-[0.35em] text-terra" data-testid="not-found-kicker">
          Page not found
        </h1>
        <MaskedLines
          as="p"
          className="mt-8 font-serif text-5xl font-light leading-[0.95] tracking-tighter text-forest sm:text-6xl"
          lines={["Page not found."]}
        />
        <Reveal delay={0.2}>
          <p className="mt-8 text-base leading-relaxed text-ink/70" data-testid="not-found-message">
            That page doesn&rsquo;t exist or has moved.
          </p>
          <nav className="mt-10 flex flex-wrap gap-4" data-testid="not-found-links">
            {links.map(([label, to]) => (
              <Link
                key={to}
                to={to}
                data-testid={`not-found-link-${label.toLowerCase()}`}
                className="group inline-flex items-center gap-1.5 rounded-full border border-border px-5 py-2 text-sm text-forest transition-colors duration-300 hover:border-terra hover:text-terra"
              >
                {label}
                <ArrowUpRight className="h-3.5 w-3.5" strokeWidth={2} />
              </Link>
            ))}
          </nav>
        </Reveal>
      </section>
    </div>
  );
}
